import { useEffect } from 'react';
import useActivityCreate from 'modules/queries/account/activity/create';

export function useProductConfigIntent(product: string | unknown) {
	const { mutateAsync: activityCreate } = useActivityCreate();

	useEffect(() => {
		if (!product) return;
		if (typeof product !== 'string') return;

		activityCreate({
			type: 'Product Configuration',
			product_identifier: product.slice(0, 255),
		}).catch(() => 0);
	}, [product, activityCreate]);
	return null;
}

export default useProductConfigIntent;
